import { ExpandIcon } from "$components/icons";
import { withStyles } from "$components/mui-styles";
import {
  type AccordionSummaryProps,
  Box,
  type BoxProps,
  AccordionSummary as MUIAccordionSummary,
} from "@material-ui/core";
import { useContext } from "react";
import { CardContext } from "./context";

// The summary owns the card's responsive horizontal padding (the expandable
// Card sets its own padding to 0), so header content lines up with the rest of
// the card body. paddingBottom is 0 so the details sit directly beneath.
const AccordionSummary = withStyles((theme) => ({
  root: {
    alignItems: "flex-start",
    padding: theme.spacing(1),
    paddingBottom: 0,
    minHeight: "auto",
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(2),
      paddingBottom: 0,
    },
    "&.Mui-expanded": {
      minHeight: "auto",
    },
    // A disabled summary marks a non-toggleable card; it should look and read
    // like an enabled one, just without the pointer affordance.
    "&.Mui-disabled": {
      opacity: 1,
      cursor: "default",
    },
  },
  content: {
    margin: 0,
    paddingRight: theme.spacing(2),
    "&.Mui-expanded": {
      margin: 0,
    },
  },
  // Rein in MUI's default -12px so the 48px icon button stays inside the card
  // padding rather than spilling past the (clipped) card edge.
  expandIcon: {
    marginRight: theme.spacing(-1),
  },
}))((props: AccordionSummaryProps) => <MUIAccordionSummary {...props} />);

const CardSummary = ({ children, ...props }: BoxProps) => {
  const { expandable, hideExpandIcon } = useContext(CardContext);

  return (
    <>
      {expandable ? (
        <AccordionSummary
          expandIcon={hideExpandIcon ? undefined : <ExpandIcon />}
        >
          <Box flex={1} {...props}>
            {children}
          </Box>
        </AccordionSummary>
      ) : (
        <Box flex={1} {...props}>
          {children}
        </Box>
      )}
    </>
  );
};

export default CardSummary;
